import { List } from '@zillow/constellation';
import { propertyUtils } from '@zg-rentals/rental-manager-env';

import { useSelector } from '../../../../selectors/useSelector';

const WizardTipContent = () => {
  const currentProperty = useSelector((state) => state.properties.currentProperty);
  const isRoomForRent = propertyUtils.isRoomForRent({ currentProperty });

  const maintenanceDisplay = isRoomForRent
    ? `Outline renter responsibilities for maintenance, if any.`
    : `Outline tenant responsibilities for maintenance, if any.`;

  return (
    <div data-testid="WizardTipContent">
      <List paddingLeft="md">
        <List.Item>Include the lease duration.</List.Item>
        <List.Item>
          Add your smoking and parking policies, as well as any other pet policy details not already covered.
        </List.Item>
        <List.Item>{maintenanceDisplay}</List.Item>
      </List>
    </div>
  );
};

export default WizardTipContent;
